import React from 'react';
import { useLocale } from '@adsk/alloy-react-helpers';
import { RadioButton, RadioGroup } from '@adsk/alloy-react-radio-button';
import { useStore } from '@common/StoreProvider';
import { USER_ACCESSES } from '../../constants';
import { fieldStyle } from '../../styles';
import {
  radioLabelStyles,
  radioTextStyles,
  accessDescriptionStyles,
} from './helpers/styles';
import { ACTIONS } from '../../state/actions';

const AccessLevel = () => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));
  const { state, dispatch } = useStore();

  const handleAccessLevelChange = (value) => {
    dispatch({
      type: ACTIONS.SET_ACCESS_LEVEL,
      payload: value,
    });
  };

  return (
    <div css={fieldStyle} data-testid="InviteProjectMemberModal_access_field">
      <RadioGroup
        data-testid="InviteProjectMemberModal_access_field_radio_group"
        name="accessLevel"
        onChange={handleAccessLevelChange}
        value={state.selectedAccessLevel}
      >
        <label css={radioLabelStyles}>
          <RadioButton
            data-testid="InviteProjectMemberModal_access_field_radio_group_member_button"
            value={USER_ACCESSES.MEMBER}
          />
          <span css={radioTextStyles}>{T.translate('PROJECT_MEMBER')}</span>
        </label>
        <span css={accessDescriptionStyles}>
          {T.translate('PROJECT_MEMBER_DESCRIPTION')}
        </span>
        <label css={radioLabelStyles}>
          <RadioButton
            data-testid="InviteProjectMemberModal_access_field_radio_group_admin_button"
            value={USER_ACCESSES.ADMIN}
          />
          <span css={radioTextStyles}>{T.translate('PROJECT_ADMIN')}</span>
        </label>
        <span css={accessDescriptionStyles}>
          {T.translate('PROJECT_ADMIN_DESCRIPTION')}
        </span>
      </RadioGroup>
    </div>
  );
};

export default AccessLevel;
